import { EventEmitter, Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../app.constants';
import { BehaviorSubject } from 'rxjs';
import { Output } from '@angular/core/src/metadata';

@Injectable()
export class PayorsService extends ParentService {
  selectedPayorId = new BehaviorSubject<Number>(null);
  selectedPayorId$ = this.selectedPayorId.asObservable();
  selectedReasonId = new BehaviorSubject<Number>(null);
  selectedReasonId$ = this.selectedReasonId.asObservable();
  selectedHistoryId = new BehaviorSubject<number>(null);
  selectedHistoryId$ = this.selectedHistoryId.asObservable();
  save = new BehaviorSubject<boolean>(false);
  save$ = this.save.asObservable();

  @Output() restartModal = new EventEmitter();

  smartTableData = [];

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name getArray
   * @description
   * @param {string} method
   */
  getArray(method: string) {
    this.getPayors(method)
    .subscribe(
      data => this.smartTableData = data
    );
  }

  /**
   * @name searchFacilityById
   * @description
   * @param facilityId
   */
  searchFacilityById(facilityId) {
    return this._http
      .get(constant.URL_FACILITY + '/' + facilityId, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @name getPayorsAll
   * @description
   */
  getPayorsAll() {
    return this._http
      .get(constant.URL_PAYOR + '/list', this.getHeader())
      .map(res => res.json());
  }


  getPayorsActiveInactive(showInactive = false) {
    return this._http
      .get(`${constant.URL_PAYOR}/list?showInactive=${showInactive}`, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getPayorFacilities
   * @description
   * @param payorid
   */
  getPayorFacilities(payorid) {
    return this._http
      .get(constant.URL_PAYOR_FACILITY + payorid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getPayorsByPayorId
   * @description
   * @param payorId
   */
  getPayorsByPayorId(payorId) {
    return this._http
      .get(constant.URL_PAYOR + '/' + payorId, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getPayors
   * @description
   * @param param
   */
  getPayors(param: string) {
    if (param === null) {
      return this._http
        .get(constant.URL_PAYOR, this.getHeader())
        .map(res => res.json());
    } else {
      return this._http
        .get(constant.URL_PAYOR + '?description=' + param, this.getHeader())
        .map(res => res.json());
    }
  }

  /**
   * @name getBillingSchedule
   * @description
   */
  getBillingSchedule() {
    return this._http
      .get(constant.URL_BILLING_SCHEDULE, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getImportTemplate
   * @description Get pata los import Templates
   */
  getImportTemplate() {
    return this._http
      .get(constant.URL_IMPORT_TEMPLATE, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getPayorCallTypes
   * @description
   * @param payorid
   */
  getPayorCallTypes(payorid) {
    return this._http
      .get(constant.URL_PAYOR + '/' + payorid + '/CallTypes', this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getBillPation
   * @description
   */
  getBillPation() {
    return this._http
      .get(constant.URL_BILL_PATIENT, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getFeeScheduleService
   * @description
   * @param showDisableData
   * @param payorIdData
   */
  getFeeScheduleService(showDisableData, payorIdData) {
    return this._http
      .get(constant.URL_FEE_SCHEDULE + '?showDisable=' + showDisableData + '&payorId=' + payorIdData, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getFeeScheduleById
   * @description
   * @param feeScheduleId
   */
  getFeeScheduleById(feeScheduleId: number) {
    return this._http
      .get(constant.URL_FEE_SCHEDULE + '/' + feeScheduleId, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getData
   * @description
   * @param method
   */
  getData(method: string): Promise < any > {
    this.getArray(method);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.smartTableData);
      }, 2000);
    });
  }

  /**
   * @name getAllPlans
   * @description
   * @param inactive
   * @param payorid
   */
  getAllPlans(inactive, payorid) {
    return this._http
      .get(constant.URL_PAYOR_PLANS + '/' + payorid + '/' + inactive, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @name getPlanById
   * @description
   * @param id
   */
  getPlanById(id) {
    return this._http
      .get(constant.URL_PAYOR_PLAN + '/' + id, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @name postPayorPlan
   * @description
   * @param data
   */
  postPayorPlan(data) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_PAYOR_PLAN, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getPayorReasonForTransport
   * @description get reason for transport by payorid
   * @param payorid
   * @returns {Observable<any>}
   */
  getPayorReasonForTransport(payorid: number, isActive?: boolean): Observable<any> {
    const url = `${constant.URL_REASON_TRANSPORT_LIST}/${payorid}?showInactive=${isActive}`;
    return this._http
      .get(url, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @name postReasonForTransport
   * @description
   * @param data
   */
  postReasonForTransport(data) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_PAYOR_REASON_TRANSPORT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putReasonForTransport
   * @description
   * @param data
   */
  putReasonForTransport(data) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_PAYOR_REASON_TRANSPORT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getReasonById
   * @description
   * @param id
   */
  getReasonById(id) {
    return this._http
      .get(constant.URL_PAYOR_REASON_TRANSPORT + '/' + id, this.getHeader()).map(resp => resp.json());
  }

  /**
   * @name deleteReasonForTransport
   * @description
   * @param id
   */
  deleteReasonForTransport(id) {
    return this._http
      .delete(`${constant.URL_PAYOR_REASON_TRANSPORT}/${id}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putPayorPlan
   * @description
   * @param data
   */
  putPayorPlan(data) {
    delete data.addedon;
    delete data.modifiedon;
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_PAYOR_PLAN, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name deletePlan
   * @description
   * @param data
   */
  deletePlan(data: any) {
    return this._http
      .put(`${constant.URL_PAYOR_PLAN}/${data}`, {}, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putPayorFacility
   * @description
   * @param data
   */
  putPayorFacility(data: any) {
    // data.isactive=!data.isactive
    const bodyString = JSON.stringify(data);

    return this._http.put(constant.URL_FACILITY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name postPayorFacility
   * @description
   * @param data
   */
  postPayorFacility(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http.post(constant.URL_FACILITY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name postData
   * @description
   * @param data
   */
  postData(data: any) {
    // data.isactive=!data.isactive
    const bodyString = JSON.stringify(data);

    return this._http.post(constant.URL_PAYOR, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putDataPayor
   * @description
   * @param data
   */
  putDataPayor(data: any) {
    delete data['feeschedules'];
    const bodyString = JSON.stringify(data);

    return this._http.put(constant.URL_PAYOR, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name deleteDataPayor
   * @description
   * @param data
   */
  deleteDataPayor(data: any) {
    return this._http
      .delete(`${constant.URL_PAYOR}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name postCreateNewFeeSchedule
   * @description
   * @param data
   */
  postCreateNewFeeSchedule(data: any) {
    const dataSend = data.feeschedules[0];
    const bodyString = JSON.stringify(dataSend);

    return this._http.post(constant.URL_FEE_SCHEDULE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putFeeSchedule
   * @description
   * @param data
   */
  putFeeSchedule(data: any) {
    const dataSend = data.feeschedules[0];
    const bodyString = JSON.stringify(dataSend);

    return this._http.put(constant.URL_FEE_SCHEDULE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name deleteDataFeeSchedule
   * @description
   * @param data
   */
  deleteDataFeeSchedule(data: any) {

    return this._http
      .delete(`${constant.URL_FEE_SCHEDULE}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param data
   */
  putData(data: any) {
    const bodyString = JSON.stringify(data);

    return this._http.put(constant.URL_RIDER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()|| 'Server error'));
  }

  /**
   * @name deleteData
   * @description
   * @param data
   */
  deleteData(data: any) {

    return this._http
      .delete(`${constant.URL_RIDER}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name putFeeScheduleV2
   * @description
   * @param data
   */
  putFeeScheduleV2(data: any) {
    const dataSend = data;
    const bodyString = JSON.stringify(dataSend);
    delete data.charge;

    return this._http.put(constant.URL_FEE_SCHEDULE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name deleteRate
   * @description
   * @param data
   */
  deleteRate(data: any) {
    return this._http
      .delete(`${constant.URL_RATE}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name postCreateNewRate
   * @description
   * @param data
   */
  postCreateNewRate(data: any) {
    const dataSend = data;
    const bodyString = JSON.stringify(dataSend);

    return this._http.post(constant.URL_RATE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param payorid
   * @returns {Observable<any>}
   */
  getExcludeProvVyPayor( payorid ) {
    return this._http.get(constant.URL_EXCLUDE_PROV_LIST_BY_PAYOR + '/' + payorid, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  deleteExcludeProviders(data: any) {
    return this._http.delete(`${constant.URL_SAVE_EXCLUDE_PROV}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  postExcludeProviders(data) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_SAVE_EXCLUDE_PROV, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description:
   * @returns {Observable<any>}
   */
  getPayorList() {
    return this._http.get(constant.URL_PAYOR_LIST, this.getHeader())
      .map(resp => resp.json());
  }

  /**@name getHistoryPayor
   * @description Trae el historial de cambios del Payor
   * @param payorId = Id del payor
   */
  getHistoryPayor(payorId: number) {
    return this._http.get(`${constant.URL_PAYOR_HISTORY}${payorId}`, this.getHeader())
      .map(resp => resp.json())
      .catch(error => Observable.throw(error.json()));
  }

  /**@name getSimplyReasonTransport
 * @description return register of "SimplyReasonTransport"
 */
  getSimplyReasonTransport() {
    return this._http.get(`${constant.URL_SIMPLY_REASON_TRANSPORT}`, this.getHeader())
      .map(resp => resp.json())
      .catch(error => Observable.throw(error.json()));
  }

  /**@name getUsersPayor
   * @param payorId = Id del payor
   */
  getUsersPayor(payorId: number) {
    return this._http.get(`${constant.URL_PAYOR_USERS}${payorId}`, this.getHeader())
      .map(resp => resp.json())
      .catch(error => Observable.throw(error.json()));
  }

  /**
   * @name getPayorsAllShowInactive
   * @description
   */
  getPayorsAllPosting() {
    return this._http
      .get(constant.URL_PAYOR + '/list?showInactive=true', this.getHeader())
      .map(res => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getEncounterType() {
    return this._http
      .get(constant.URL_PAYOR_ENCOUNTERTYPE, this.getHeader())
      .map(res => res.json())
      .catch(error => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/payors/payors.service.ts